import { render, staticRenderFns } from "./SharePackageCrud.vue?vue&type=template&id=03588e2a&scoped=true&"
import script from "./SharePackageCrud.vue?vue&type=script&lang=js&"
export * from "./SharePackageCrud.vue?vue&type=script&lang=js&"
import style0 from "./SharePackageCrud.vue?vue&type=style&index=0&id=03588e2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03588e2a",
  null
  
)

export default component.exports